export default __webpack_public_path__ + "static/media/gzh.f2ed1aa0.jpg";